import { Component, Inject, OnDestroy, OnInit, Optional, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SupportHelpCenterLink } from '~app/modules/generic/constants/support-help-center-link';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { MmPopoverRef, MmPopoverService } from '~shared/modules/popover/popover.module';
import { UserInfoState, isEntrepreneur } from '~shared/modules/user-info/store';
import { SupportPhoneNumbers } from '../../constants';
import { HeaderLogoUtil } from '../../utils/header-logo.util';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { IS_COMPANION } from '~app/app.module';

@Component({
  selector: 'app-generic-header-simplified',
  templateUrl: './header-simplified.component.html',
  styleUrls: ['./header-simplified.component.scss'],
})
export class HeaderSimplifiedComponent implements OnInit, OnDestroy {
  market;
  helpPhoneNumber;
  destroySubject$ = new Subject();
  isMobile = false;
  popoverStyles: { [key: string]: string | number };
  helpCenterPopoverRef: MmPopoverRef;
  helpCenterLink: string;
  public readonly logoClassName: string;

  @ViewChild('helpPopover') popoverContent: TemplateRef<any>;

  constructor(
    private readonly store: Store<UserInfoState>,
    private readonly popoverSvc: MmPopoverService,
    private readonly mediaObserver: MediaObserver,
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any,
    @Optional() @Inject(IS_COMPANION) public isMCompanion
  ) {
    this.market = getCountryDomainCode(this.webAppBuyerRequest);
    this.logoClassName = HeaderLogoUtil.getHeaderLogoName(this.market);
    this.helpPhoneNumber = SupportPhoneNumbers[this.market];
    this.helpCenterLink = SupportHelpCenterLink[this.market];
  }

  ngOnInit(): void {
    this.store.pipe(select(isEntrepreneur), takeUntil(this.destroySubject$)).subscribe((userIsEntrepreneur) => {
      this.helpPhoneNumber = userIsEntrepreneur ? this.helpPhoneNumber?.b2b : this.helpPhoneNumber?.b2c;
    });

    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(() => {
        if (!this.isMobile && this.helpCenterPopoverRef) {
          this.helpCenterPopoverRef.close();
        }
        this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
      });
  }

  showHelpCenterPopover(origin: HTMLSpanElement) {
    this.helpCenterPopoverRef = this.popoverSvc.open({
      origin,
      content: this.popoverContent,
      offsetY: 10,
    });
  }

  closeHelpPopover() {
    if (this.helpCenterPopoverRef) {
      this.helpCenterPopoverRef.close();
    }
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
